import React from "react";
import "./Components/App.css";
import WhatsappLogo from './images/whatsapp-icon.png';
import InstagramLogo from './images/insta-icon.png';
import TiktokLogo from './images/tiktok-icon.png';
import GymHouseLogo from './images/gymHouse-logo.png';
import GoogleMapsLogo from './images/GoogleMaps-icon.png';
import marioPhoto from './images/Team/marioKassab.jpeg';
import { useNavigate } from "react-router-dom";

export default function TheHouse()  {    
  const navigate = useNavigate();
    return (      
      
            <div className="default-page">
            <img alt="Welcome to GymHouse" className="gymHouse-Logo" onClick={()=>{                 
                  navigate('/')}} src={GymHouseLogo}></img>
              <h1><b>Welcome To Our House</b></h1>
              <div className="spacer"></div>
              <div className="spacer"/>
              <h2><b>Check us!</b></h2>
              <div className="spacer"/>
              <div className="spacer"/>
              <hr/>
              
                <div className="meet-us-container">
                <li><img alt="Meet our founder" className="photos" src={marioPhoto}></img></li>
                <li><img alt="Meet our founder"className="photos" src={marioPhoto}></img></li>        
                <li><img alt="Meet our founder" className="photos" src={marioPhoto}></img></li>
                <li><img alt="Meet our founder" className="photos" src={marioPhoto}></img></li>
                <li><img alt="Meet our founder" className="photos" src={marioPhoto}></img></li>
                <li><img alt="Meet our founder" className="photos" src={marioPhoto}></img></li>
                </div>
                <hr/>
                
                <h2><b>How to find us?</b></h2>
                <div className="icons-container">
                <li><a target="blank" href="https://wa.me/+96171453095" ><img alt="Reach us on Whatsapp" className="icons" src={WhatsappLogo}></img></a></li>
                <li><a target="blank" href="https://www.instagram.com/gymhouse_lb?igsh=MWpsaGZzOXppM3I5Zg%3D%3D&utm_source=qr"><img alt="Reach us on Instagram" className="icons" src={InstagramLogo}></img></a> </li>
                <li><a target="blank" href="https://www.tiktok.com/@gymhouse_lb?_t=8j1PECEQvuE&_r=1"><img alt="Reach us on Tiktok" className="icons" src={TiktokLogo}></img></a> </li>
                <li><a target="blank" href="https://maps.app.goo.gl/JEc6kySrX7HA9N1S8 " ><img alt="Find us on GoogleMaps" className="icons" src={GoogleMapsLogo}></img></a></li>
                </div>
                <hr/>
              </div> 
    );
  }

